import { Reveal, MaskedLines } from "./Reveal";
import { MANIFESTO, WHY } from "../../data/content";
import { Check } from "lucide-react";

export default function Manifesto() {
  return (
    <section id="approach" data-testid="manifesto-section" className="bg-white py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-8 mb-20">
          <div className="lg:col-span-6">
            <p className="font-body text-xs uppercase tracking-[0.2em] font-semibold text-ov-green mb-6">
              Our Approach
            </p>
            <h2 className="font-display text-4xl md:text-5xl text-ov-navy leading-tight tracking-tight">
              <MaskedLines trigger="scroll" lines={["A single, unified", "opinion you can", "act on."]} />
            </h2>
          </div>
        </div>

        <div className="space-y-px bg-ov-navy/10 border-y border-ov-navy/10">
          {MANIFESTO.map((m, i) => (
            <Reveal key={m.no} delay={i * 0.05}>
              <div className="grid lg:grid-cols-12 gap-6 items-start bg-white py-12 px-2 group hover:bg-ov-greenPale/40 transition-colors duration-300">
                <div className="lg:col-span-4">
                  <span className="font-display text-6xl md:text-7xl text-ov-navy/15 group-hover:text-ov-green/40 transition-colors duration-300">
                    {m.no}
                  </span>
                </div>
                <div className="lg:col-span-6">
                  <h3 className="font-display text-2xl md:text-3xl text-ov-navy mb-4">{m.title}</h3>
                  <p className="font-body text-base md:text-lg text-ov-charcoal/70 leading-relaxed">{m.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        {/* Why choose */}
        <div className="mt-20 grid lg:grid-cols-12 gap-8 items-center">
          <div className="lg:col-span-5">
            <h3 className="font-display text-3xl md:text-4xl text-ov-navy leading-tight">
              Why choose <span className="text-ov-green italic">One Vision</span>?
            </h3>
          </div>
          <div className="lg:col-span-7">
            <ul className="grid sm:grid-cols-2 gap-x-8 gap-y-5">
              {WHY.map((w, i) => (
                <Reveal key={w} delay={i * 0.06}>
                  <li className="flex items-start gap-3">
                    <span className="mt-0.5 flex-shrink-0 w-6 h-6 rounded-full bg-ov-green/10 flex items-center justify-center">
                      <Check size={14} className="text-ov-green" />
                    </span>
                    <span className="font-body text-ov-charcoal/80">{w}</span>
                  </li>
                </Reveal>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
